/*  @flow */
import * as React from 'react';

import ActionButton from 'components/ActionsList/components/ActionButton/ActionButton';

import {
  readViewAsUser,
  readLoginAsUser,
  updateExistingUserRole,
  updateRevokeAccess,
  auditLocation,
  updateEditLocation,
} from 'permissions/account';

export const actionsListManageUsers = [
  {
    label: 'general:actions.change_role',
    icon: '#icon-edit',
    class: '',
    action: 'changeUserRole',
    permissions: updateExistingUserRole,
  },
  {
    label: 'general:actions.view_as_user',
    icon: '#icon-view-as-user',
    class: '',
    action: 'viewAsUser',
    permissions: readViewAsUser,
  },
  {
    label: 'general:actions.login_as_user',
    icon: '#icon-login-as-user',
    class: '',
    action: 'loginAsUser',
    permissions: readLoginAsUser,
  },
  {
    label: 'general:actions.remove_user',
    icon: '#icon-revoke-user',
    class: '',
    action: 'revokeUserAccess',
    permissions: updateRevokeAccess,
  },
  {
    label: 'general:actions.start_audit_from_users',
    icon: '#icon-approve',
    class: '',
    action: 'startAuditByUsers',
    permissions: auditLocation,
    condition(data: Object, action: Object, callback: Function): React.Node {
      if (data.assets_count) {
        return <ActionButton data={data} action={action} onActionDrawer={callback} />;
      }
    },
  },
];

export const actionsListSpecificUser = [
  ...actionsListManageUsers,
  {
    label: 'general:actions.assign_location',
    icon: '#icon-change-location',
    class: '',
    action: 'assignOrChangeUserLocation',
    permissions: updateEditLocation,
    condition(data: Object, action: Object, callback: Function) {
      if (!data.location) {
        return <ActionButton data={data} action={action} onActionDrawer={callback} />;
      }
    },
  },
  {
    label: 'general:actions.change_location',
    icon: '#icon-change-location',
    class: '',
    action: 'assignOrChangeUserLocation',
    permissions: updateEditLocation,
    condition(data: Object, action: Object, callback: Function) {
      if (data.location) {
        return <ActionButton data={data} action={action} onActionDrawer={callback} />;
      }
    },
  },
  {
    label: 'general:actions.remove_location',
    icon: '#icon-archive',
    class: '',
    action: 'removeUserLocation',
    permissions: updateEditLocation,
    condition(data: Object, action: Object, callback: Function) {
      if (data.location) {
        return <ActionButton data={data} action={action} onActionDrawer={callback} />;
      }
    },
  },
];
